( function( global, $ ) {
    "use strict";

    var $body = $('body'),
        $main = $('#main');

    var TEMPLATE = [
        '<div id="contact_tooltip" class="contact-tooltip" contact-tooltip>',
            '<div class="contact-tooltip__inner">',
                '<button class="contact-tooltip__close" aria-label="close" contact-tooltip-close></button>',
                '<div class="contact-tooltip__body">',
                    '<div class="contact-tooltip__title" contact-tooltip-title></div>',
                    '<ul class="contact-tooltip__details" contact-tooltip-details></ul>',
                '</div>',
                '<div class="contact-tooltip__footer" contact-tooltip-footer>',
                    '<a href="#" class="btn btn--outline btn--icon btn--white" contact-tooltip-edit-link>',
                        '<i class="icon-fa-pencil" aria-hidden="true"></i>',
                    '</a>',
                    '<a href="#" class="btn btn--primary" contact-tooltip-show-link>Plus de détails</a>',
                '</div>',
                '<div class="contact-tooltip__status" contact-tooltip-status></div>',
            '</div>',
        '</div>'
    ].join('');

    var _events = {
        onClickContactLabel: function (ev) {
            ev.preventDefault();

            $(document).off('click.contact-tooltip');

            var $contactTooltip = $('#contact_tooltip');

            if (! $contactTooltip.length) {
                $contactTooltip = $(TEMPLATE).attr('id', 'contact_tooltip').appendTo($main);
            }

            $contactTooltip.toggleClass('hidden', false);

            var $contactInfo = $(ev.currentTarget),
                title = $contactInfo.find('.signature__info .signature__name').text(),
                hasLink = $contactInfo.find('a').length !== 0;

            $contactTooltip.data('contact-tooltip.contact-info', $contactInfo);

            $contactTooltip.find('[contact-tooltip-title]').text(title);
            $contactTooltip.find('[contact-tooltip-details]').html('');
            $contactTooltip.find('[contact-tooltip-footer]').toggleClass('hidden', !hasLink);

            if (hasLink) {
                $contactTooltip.find('[contact-tooltip-show-link]').attr('href', $contactInfo.data('show-url'));
                $contactTooltip.find('[contact-tooltip-edit-link]').attr('href', $contactInfo.data('edit-url'));
            } else {
                $contactTooltip.find('[contact-tooltip-show-link]').attr('href', '#');
                $contactTooltip.find('[contact-tooltip-edit-link]').attr('href', '#');
            }

            $contactTooltip.trigger('adjust.contact-tooltip');
            $contactTooltip.trigger('fetch.contact-tooltip');

            setTimeout(function () {
                $(document).on('click.contact-tooltip', function (ev) {
                    if ($contactTooltip.get(0) !== ev.target && ! $.contains($contactTooltip.get(0), ev.target)) {
                        $contactTooltip.find('[contact-tooltip-close]').trigger('click.contact-tooltip');
                    }
                });
            }, 0);
        },

        onAdjust: function (ev, source) {
            var $contactTooltip = $(this),
                $contactInfo = $contactTooltip.data('contact-tooltip.contact-info');

            var contactInfoOffset = $contactInfo.offset(),
                tooltipOffset = {
                    top: contactInfoOffset.top - 40 - $contactTooltip.height(),
                    left: contactInfoOffset.left + ($contactInfo.width() / 2) - ($contactTooltip.width() / 2) - 20
                };

            tooltipOffset.top = tooltipOffset.top < 0 ? 0 : tooltipOffset.top;
            tooltipOffset.left = tooltipOffset.left < 0 ? 0 : tooltipOffset.left;

            $contactTooltip.offset(tooltipOffset);

            if (source !== 'window.resize' && tooltipOffset.top - 20 < $(window).scrollTop()) {
                $(window).scrollTop(tooltipOffset.top - 20);
            }
        },

        onFetch: function (ev) {
            var $contactTooltip = $(this),
                $contactInfo = $contactTooltip.data('contact-tooltip.contact-info'),
                $contactStatus = $contactTooltip.find('[contact-tooltip-status]'),
                $details = $contactTooltip.find('[contact-tooltip-details]'),
                contactInfo = $contactInfo.data('contact-info'),
                endpoint = contactInfo.collection + '/' + contactInfo.resource;

            $contactStatus.text('Chargement...').toggleClass('hidden', false);

            $.App.api('GET', endpoint)
                .done(function (response) {
                    var resource = response.resource;

                    $details.html('');

                    $.each(resource.phones, function () {
                        $details.append([
                            '<li>',
                                '<strong>'+this.formatted_type_name+':</strong> ',
                                '<a href="'+this.link+'" class="link">'+this.formatted_number_ext+'</a>',
                            '</li>'
                        ].join(''));
                    });

                    if (resource.email) {
                        $details.append([
                            '<li>',
                                '<strong>Adresse courriel:</strong> ',
                                '<a href="mailto:'+resource.email+'" class="link">'+resource.email+'</a>',
                            '</li>'
                        ].join(''));
                    }

                    $.each(resource.addresses, function () {
                        $details.append(
                            '<li><strong>Adresse:</strong> '+this.formatted_name+'</li>'
                        );
                    });

                    if (resource.tags) {
                        var $tags = $('<li class="tags" \>');

                        $.each(resource.tags, function () {
                            $tags.append(
                                '<strong class="tag u-margin-top-sm">'+this.name+'</strong>'
                            );
                        });

                        $details.append($tags);
                    }

                    $contactTooltip.trigger('adjust.contact-tooltip');
                })
                .fail(function () {
                    $contactTooltip.find('[contact-tooltip-details]').html('');
                })
                .always(function () {
                    $contactStatus.text('').toggleClass('hidden', true);
                });
        },

        onClickClose: function (ev) {
            ev.preventDefault();

            $('#contact_tooltip').toggleClass('hidden', true);

            $(document).off('click.contact-tooltip');
        },

        onResizeWindow: function () {
            $('#contact_tooltip').trigger('adjust.contact-tooltip', ['window.resize']);
        }
    };

    $body.on('app.ready', function (ev) {
        $body
            .on('fetch.contact-tooltip', '#contact_tooltip', _events.onFetch)
            .on('adjust.contact-tooltip', '#contact_tooltip', _events.onAdjust)
            .on('click.contact-tooltip', '[data-contact-info]', _events.onClickContactLabel)
            .on('click.contact-tooltip', '#contact_tooltip [contact-tooltip-close]', _events.onClickClose)

        $(window).on('resize.contact-tooltip', _events.onResizeWindow);
    });

}( window.groots, jQuery ));
